class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');

    this.onBodyClick = this.handleBodyClick.bind(this);
    this.close = this.close.bind(this);
    this.pauseAutoClose = this.pauseAutoClose.bind(this);
    this.restartAutoClose = this.restartAutoClose.bind(this);

    /*
     * 通知显示时间。
     * 4000代表4秒，5000代表5秒。
     */
    this.autoCloseDelay = 4000;
    this.autoCloseTimer = null;

    if (!this.notification) {
      return;
    }

    /*
     * 按ESC关闭
     */
    this.notification.addEventListener('keyup', (event) => {
      if (event.code === 'Escape') {
        this.close();
      }
    });

    /*
     * 通知框内的关闭按钮
     */
    this.querySelectorAll('button[type="button"]').forEach((closeButton) => {
      closeButton.addEventListener('click', this.close);
    });

    /*
     * 鼠标放到通知框上时暂停自动关闭，
     * 鼠标离开后重新计算4秒。
     */
    this.notification.addEventListener(
      'mouseenter',
      this.pauseAutoClose
    );

    this.notification.addEventListener(
      'mouseleave',
      this.restartAutoClose
    );
  }

  open() {
    if (!this.notification) {
      return;
    }

    /*
     * 防止重复打开时叠加多个计时器
     */
    this.clearAutoClose();

    /*
     * 添加active后，CSS会让通知框从右侧滑入
     */
    this.notification.classList.add('animate', 'active');

    /*
     * 动画完成后，将焦点放到通知框
     */
    this.notification.addEventListener(
      'transitionend',
      () => {
        if (!this.notification.classList.contains('active')) {
          return;
        }

        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    /*
     * 点击通知框外部时关闭
     */
    document.body.removeEventListener(
      'click',
      this.onBodyClick
    );

    document.body.addEventListener(
      'click',
      this.onBodyClick
    );

    /*
     * 4秒后自动关闭
     */
    this.startAutoClose();
  }

  close() {
    if (!this.notification) {
      return;
    }

    /*
     * 清除自动关闭计时器
     */
    this.clearAutoClose();

    /*
     * 移除active后，CSS会让通知框滑回右侧
     */
    this.notification.classList.remove('active');

    document.body.removeEventListener(
      'click',
      this.onBodyClick
    );

    removeTrapFocus(this.activeElement);
  }

  startAutoClose() {
    this.clearAutoClose();

    this.autoCloseTimer = window.setTimeout(() => {
      this.close();
    }, this.autoCloseDelay);
  }

  pauseAutoClose() {
    this.clearAutoClose();
  }

  restartAutoClose() {
    if (
      this.notification &&
      this.notification.classList.contains('active')
    ) {
      this.startAutoClose();
    }
  }

  clearAutoClose() {
    if (this.autoCloseTimer) {
      window.clearTimeout(this.autoCloseTimer);
      this.autoCloseTimer = null;
    }
  }

  renderContents(parsedState) {
    this.cartItemKey = parsedState.key;

    this.getSectionsToRender().forEach((section) => {
      const targetElement = document.getElementById(section.id);

      if (!targetElement) {
        return;
      }

      targetElement.innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
    });

    if (this.header) {
      this.header.reveal();
    }

    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    if (!html) {
      return '';
    }

    const parsedDocument = new DOMParser().parseFromString(
      html,
      'text/html'
    );

    const selectedElement = parsedDocument.querySelector(selector);

    return selectedElement ? selectedElement.innerHTML : '';
  }

  handleBodyClick(event) {
    const target = event.target;

    if (
      target !== this.notification &&
      !target.closest('cart-notification')
    ) {
      const disclosure = target.closest(
        'details-disclosure, header-menu'
      );

      this.activeElement = disclosure
        ? disclosure.querySelector('summary')
        : null;

      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }

  disconnectedCallback() {
    this.clearAutoClose();

    document.body.removeEventListener(
      'click',
      this.onBodyClick
    );

    if (this.notification) {
      this.notification.removeEventListener(
        'mouseenter',
        this.pauseAutoClose
      );

      this.notification.removeEventListener(
        'mouseleave',
        this.restartAutoClose
      );
    }
  }
}

if (!customElements.get('cart-notification')) {
  customElements.define(
    'cart-notification',
    CartNotification
  );
}